import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RELEASE_NOTE_DESCRIPTION_MAX_LENGTH, RELEASE_NOTE_NAME_MAX_LENGTH } from 'modules/releases/constants';
import { Input } from 'ui/base';

export const countRules = {
  show: ({ count, maxLength }) => {
    const valid = count <= maxLength;

    return (
      <span className={classNames({ 'text-success-light': valid, 'text-danger': !valid })}>
        {count}/{maxLength}
      </span>
    );
  },
};

export const GENERAL_FIELDS = [
  {
    name: 'name',
    required: true,
    parse: v => v || '', // to avoid null value
    label: <FormattedMessage id="name" defaultMessage="Name" />,
    componentProps: { maxLength: RELEASE_NOTE_NAME_MAX_LENGTH, count: countRules },
  },
  {
    required: true,
    name: 'description',
    label: <FormattedMessage id="description" defaultMessage="Description" />,
    component: Input.TextArea,
    componentProps: {
      rows: 5,
      count: countRules,
      maxLength: RELEASE_NOTE_DESCRIPTION_MAX_LENGTH,
    },
  },
];

export const LINK_FIELDS = [
  {
    name: 'link.targetUrl',
    label: 'URL',
  },
  {
    name: 'link.displayText',
    label: <FormattedMessage id="page.releases.note.link.displayText" defaultMessage="Link text" />,
  },
];
